export { SuiMessageModule } from "./index";
